import React, { Component } from 'react';
import { Field, Form, Formik } from 'formik';
import { faUserCircle } from '@fortawesome/pro-light-svg-icons/faUserCircle';
import { faGlobeAmericas } from '@fortawesome/pro-light-svg-icons/faGlobeAmericas';
import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone';
import { faSignature } from '@fortawesome/pro-light-svg-icons/faSignature';
import classnames from 'classnames';
import * as Yup from 'yup';
import { GLOBAL, languages } from '../../utils/Constants';
import SaveEditSwitcher from './SaveEditSwitcher';
import LineField from '../common/Formik/LineField';
import TelInput from '../common/Formik/TelInput';

class PersonalInfoArea extends Component {
  constructor(props) {
    super(props);
    this.formik = React.createRef();
    this.state = {
      inEditMode: false,
    };
  }

  onDiscardClick = () => {
    if (this.formik.current) {
      this.formik.current.resetForm();
    }
    this.toggleEditMode();
  };

  toggleEditMode = () => {
    const { inEditMode } = this.state;

    this.setState({
      inEditMode: !inEditMode,
    });
  };

  handleSubmit = (values) => {
    const { personalInfo, onSubmit } = this.props;
    if (JSON.stringify(personalInfo) !== JSON.stringify(values)) {
      onSubmit(values);
    }
    this.toggleEditMode();
  };

  validationSchema = () => {
    const { t } = this.props;

    return Yup.object().shape({
      name: Yup.string()
        .required(t('validationRequired'))
        .min(6, t('validationMinLength', { amount: 6 })),
      phoneNumber: Yup.string().test('phoneNumber', 'validationPhoneNumber', (value) => {
        return value !== GLOBAL.INVALID;
      }),
      language: Yup.string(),
    });
  };

  render() {
    const { personalInfo, t } = this.props;

    const getLanguageText = (code) => {
      const filtered = languages.filter((lang) => lang.value === code);
      if (filtered.length <= 0) {
        return null;
      }
      return filtered[0].label;
    };

    const { inEditMode } = this.state;
    const personalInfoClasses = classnames('settings-list', { editing: inEditMode });

    return (
      <div className={personalInfoClasses}>
        <Formik ref={this.formik} enableReinitialize validationSchema={this.validationSchema()} initialValues={{ ...personalInfo }} onSubmit={this.handleSubmit}>
          {({ values }) => (
            <Form>
              <SaveEditSwitcher
                icon={faUserCircle}
                title={t('labelPersonalInfo')}
                onEditClick={this.toggleEditMode}
                onDiscardClick={this.onDiscardClick}
                inEditMode={inEditMode}
                buttons={{
                  save: t('labelSave'),
                  edit: t('labelEdit'),
                  discard: t('Discard'),
                }}
                saveAction="submit"
              />
              <div className="settings-list__item">
                <Field editing={inEditMode} icon={faSignature} name="name" component={LineField} label={t('labelName')} isStartCase />
              </div>
              <div className="settings-list__item">
                <LineField editing={inEditMode} icon={faPhone} label={`${t('labelPhoneNumber')}`} value={values.phoneNumber}>
                  <Field component={TelInput} value={values.phoneNumber} t={t} name="phoneNumber" defaultValue="" />
                </LineField>
              </div>
              <div className="settings-list__item">
                <LineField editing={inEditMode} icon={faGlobeAmericas} value={getLanguageText(values.language)} label={`${t('labelLanguage')}`}>
                  <Field component="select" name="language" className="form-control">
                    {languages.map((language) => (
                      <option key={language.value} value={language.value}>
                        {language.label}
                      </option>
                    ))}
                  </Field>
                </LineField>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default PersonalInfoArea;
